import { render, staticRenderFns } from "./TemplateCreate.vue?vue&type=template&id=776b3ddc&scoped=true"
import script from "./TemplateCreate.vue?vue&type=script&lang=js"
export * from "./TemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b3ddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776b3ddc')) {
      api.createRecord('776b3ddc', component.options)
    } else {
      api.reload('776b3ddc', component.options)
    }
    module.hot.accept("./TemplateCreate.vue?vue&type=template&id=776b3ddc&scoped=true", function () {
      api.rerender('776b3ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplateCreate.vue"
export default component.exports